import { Component, computed, inject, input, Input, LOCALE_ID, signal } from '@angular/core';
import { SuppliersService } from '../../../../services/suppliers/suppliers.service';
import {
  AdminSuppliersList,
  OneSupplierResponseData,
} from '../../../../pages/admin-dashboard/admin-supplier/admin-supplier.model';
import { finalize } from 'rxjs';
import { DateTimePipe } from '../../../../shared/utils/date-time.pipe';

@Component({
  selector: 'app-admin-supplier-details',
  imports: [DateTimePipe],
  templateUrl: './admin-supplier-details.html',
  styleUrl: './admin-supplier-details.scss',
})
export class AdminSupplierDetails {
  private locale = inject(LOCALE_ID);
  isArabic = computed(() => this.locale.startsWith('ar'));
  supplierId = input<number | null>(null);

  private supplierService = inject(SuppliersService);

  loadingSupplier = signal<boolean>(false);
  errorLoadingSupplier = signal<string | null>(null);

  supplier: OneSupplierResponseData | null = null;

  ngOnInit() {
    if (this.supplierId()) {
      this.loadSupplier();
    }
  }

  loadSupplier() {
    this.loadingSupplier.set(true);
    this.supplierService
      .getOneSupplier(+this.supplierId()!)
      .pipe(
        finalize(() => {
          this.loadingSupplier.set(false);
        }),
      )
      .subscribe({
        next: (supplier: OneSupplierResponseData) => {
          this.supplier = supplier;
        },
        error: (err: Error) => {
          console.error('Error loading supplier:', err);
          this.errorLoadingSupplier.set('Failed to load supplier. Please try again.');
        },
      });
  }
}
